import { createReducer } from '@reduxjs/toolkit';
import type { ConnectionState } from './types';
import { initialState } from './types';
import { setOnline, setOffline } from './actions';

export const connectionReducer = createReducer<ConnectionState>(
  initialState,
  (builder) => {
    builder
      .addCase(setOnline, (state) => {
        state.isOnline = true;
        state.lastChecked = Date.now();
      })
      .addCase(setOffline, (state) => {
        state.isOnline = false;
        state.lastChecked = Date.now();
      });
  },
);
